// extracted by mini-css-extract-plugin
export var li = "ProductAttribute-module--li--f1b39";
export var ul = "ProductAttribute-module--ul--c2ff5";